export default "__VITE_ASSET__6f050593__"